var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpisode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Episode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Episode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Episode-Icon",
    transform: "translate(3.500000, 3.500000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.984,24 L2.016,24 C0.904,24 0,23.096 0,21.984 L0,2.016 C0,0.904 0.904,0 2.016,0 L21.985,0 C23.096,0 24,0.904 24,2.016 L24,21.985 C24,23.096 23.096,24 21.984,24 Z M2.016,1 C1.456,1 1,1.456 1,2.016 L1,21.985 C1,22.544 1.456,23 2.016,23 L21.985,23 C22.544,23 23,22.544 23,21.984 L23,2.016 C23,1.456 22.544,1 21.984,1 L2.016,1 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,6.5 L5,6.5 C4.724,6.5 4.5,6.276 4.5,6 C4.5,5.724 4.724,5.5 5,5.5 L7,5.5 C7.276,5.5 7.5,5.724 7.5,6 C7.5,6.276 7.276,6.5 7,6.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,10.5 L5,10.5 C4.724,10.5 4.5,10.276 4.5,10 C4.5,9.724 4.724,9.5 5,9.5 L7,9.5 C7.276,9.5 7.5,9.724 7.5,10 C7.5,10.276 7.276,10.5 7,10.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,14.5 L5,14.5 C4.724,14.5 4.5,14.276 4.5,14 C4.5,13.724 4.724,13.5 5,13.5 L7,13.5 C7.276,13.5 7.5,13.724 7.5,14 C7.5,14.276 7.276,14.5 7,14.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,18.5 L5,18.5 C4.724,18.5 4.5,18.276 4.5,18 C4.5,17.724 4.724,17.5 5,17.5 L7,17.5 C7.276,17.5 7.5,17.724 7.5,18 C7.5,18.276 7.276,18.5 7,18.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,6.5 L11,6.5 C10.724,6.5 10.5,6.276 10.5,6 C10.5,5.724 10.724,5.5 11,5.5 L19,5.5 C19.276,5.5 19.5,5.724 19.5,6 C19.5,6.276 19.276,6.5 19,6.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,10.5 L11,10.5 C10.724,10.5 10.5,10.276 10.5,10 C10.5,9.724 10.724,9.5 11,9.5 L19,9.5 C19.276,9.5 19.5,9.724 19.5,10 C19.5,10.276 19.276,10.5 19,10.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,14.5 L11,14.5 C10.724,14.5 10.5,14.276 10.5,14 C10.5,13.724 10.724,13.5 11,13.5 L19,13.5 C19.276,13.5 19.5,13.724 19.5,14 C19.5,14.276 19.276,14.5 19,14.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,18.5 L11,18.5 C10.724,18.5 10.5,18.276 10.5,18 C10.5,17.724 10.724,17.5 11,17.5 L19,17.5 C19.276,17.5 19.5,17.724 19.5,18 C19.5,18.276 19.276,18.5 19,18.5 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpisode);
export default __webpack_public_path__ + "static/media/episode.7e1912cb76cab43185645f8df117fd9b.svg";
export { ForwardRef as ReactComponent };